/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Step_2Inputs */

const en_svc_agents_step_2 = /** @type {(inputs: Svc_Agents_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree what the agent may do alone and what waits for approval.`)
};

const lv_svc_agents_step_2 = /** @type {(inputs: Svc_Agents_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienojamies, ko aģents drīkst darīt pats un kas gaida apstiprinājumu.`)
};

/**
* | output |
* | --- |
* | "Agree what the agent may do alone and what waits for approval." |
*
* @param {Svc_Agents_Step_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_step_2 = /** @type {((inputs?: Svc_Agents_Step_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Step_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_step_2(inputs)
	return en_svc_agents_step_2(inputs)
});